/**
 * CS2-Bewegungskonstanten für das Kostenmodell der Wegfindung.
 *
 * Quellen: Valve Developer Wiki „CS:GO Mapper's Reference“ (Stufe 18,
 * Standsprung ~54, Crouch-Jump ~65), csdb.gg Movement-Guide (Messer
 * 250 u/s, `sv_gravity` 800), Source SDK `shareddefs.h`
 * (`PLAYER_MAX_SAFE_FALL_SPEED` 580, `PLAYER_FATAL_FALL_SPEED` 1024).
 * Die Aktionskosten (`*CostSeconds`) sind Schätzwerte für Absprung, Flugzeit
 * und Landeabbremsung – sie gewichten Aktionen gegen Laufstrecke, sie messen
 * sie nicht.
 */
const gravityHuPerSecond2 = 800;
const maxSafeFallSpeedHuPerSecond = 580;
const fatalFallSpeedHuPerSecond = 1024;
export const movement = {
    runSpeedHuPerSecond: 250,
    /** Geduckt bewegt sich der Spieler mit 34 % der Laufgeschwindigkeit. */
    crouchSpeedFactor: 0.34,
    stepHeightHu: 18,
    standingJumpHeightHu: 54,
    crouchJumpHeightHu: 65,
    gravityHuPerSecond2,
    ladderSpeedHuPerSecond: 200,
    jumpCostSeconds: 0.15,
    crouchJumpCostSeconds: 0.3,
    runJumpCostSeconds: 0.25,
    ladderMountCostSeconds: 0.5,
    /** Ein Teil der Fallzeit geht für Vorwärtsbewegung nicht verloren. */
    fallTimeLossFactor: 0.5,
    /** Gewicht eines verlorenen HP gegen Laufzeit. */
    secondsPerHealthPoint: 0.03,
    fallSeconds(heightHu) {
        return heightHu <= 0 ? 0 : Math.sqrt((2 * heightHu) / gravityHuPerSecond2);
    },
    /** Fallschaden in HP für eine Fallhöhe; ≥ 100 ist tödlich. */
    fallDamage(heightHu) {
        if (heightHu <= 0)
            return 0;
        const speed = Math.sqrt(2 * gravityHuPerSecond2 * heightHu);
        if (speed <= maxSafeFallSpeedHuPerSecond)
            return 0;
        return (((speed - maxSafeFallSpeedHuPerSecond) * 100) /
            (fatalFallSpeedHuPerSecond - maxSafeFallSpeedHuPerSecond));
    },
};
